import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentReview(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={177}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#document_review_svg__a)"
        strokeWidth={10}
        rx={16}
      />
      <path stroke="#0D2B57" d="M67 34.5h42m-42 10h42" />
      <mask
        id="document_review_svg__b"
        width={44}
        height={43}
        x={101.5}
        y={55}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M101.5 55h44v43h-44z" />
        <path d="m130.6 80.14 12.9 12.497L140.001 96l-12.857-12.529c-4.175 2.789-8.694 3.565-13.51 2.24-3.516-.97-6.305-3.016-8.407-5.95-4.246-5.928-3.454-14.28 1.819-19.36 2.662-2.568 6.182-4.117 9.918-4.366a15.9 15.9 0 0 1 10.433 3.014c6.041 4.4 8.61 13.934 3.203 21.092" />
      </mask>
      <path
        fill="#0D2B57"
        d="m130.6 80.14 12.9 12.497L140.001 96l-12.857-12.529c-4.175 2.789-8.694 3.565-13.51 2.24-3.516-.97-6.305-3.016-8.407-5.95-4.246-5.928-3.454-14.28 1.819-19.36 2.662-2.568 6.182-4.117 9.918-4.366a15.9 15.9 0 0 1 10.433 3.014c6.041 4.4 8.61 13.934 3.203 21.092"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="m130.6 80.14 12.9 12.497L140.001 96l-12.857-12.529c-4.175 2.789-8.694 3.565-13.51 2.24-3.516-.97-6.305-3.016-8.407-5.95-4.246-5.928-3.454-14.28 1.819-19.36 2.662-2.568 6.182-4.117 9.918-4.366a15.9 15.9 0 0 1 10.433 3.014c6.041 4.4 8.61 13.934 3.203 21.092Z"
        mask="url(#document_review_svg__b)"
      />
      <defs>
        <linearGradient
          id="document_review_svg__a"
          x1={88}
          x2={88}
          y1={13}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentReview);
export default ForwardRef;
